<script setup lang="ts">
/**
 * The landing's wordmark in kit lettering: the painted anchor and the name in
 * outlined `.k-title`, as a plate carries it. The top bar and the footer both
 * draw it, so they cannot drift. (`ui/BrandLogo.vue`, the thin SVG mark, stays
 * for the enlistment form and the admin bar, which have no painted ground.)
 */
import { useI18n } from '@/i18n';
import GameIcon from '@/ui/kit/GameIcon.vue';

withDefaults(defineProps<{ size?: number }>(), { size: 40 });
const { t } = useI18n();
</script>

<template>
  <span class="wordmark">
    <GameIcon name="anchor" :size="size" />
    <span class="k-title word" :style="{ fontSize: `${Math.round(size * 0.6)}px` }">{{ t('landing.brand') }}</span>
  </span>
</template>

<style scoped>
.wordmark {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.word {
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
</style>
